/**
 * Created by Jerker Nord on 2021-01-28.
 */
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {TheCage} from "../TheCage";
import {gsap} from "gsap";
import {TheCageGameMode} from "../server/TheCageGameMode";

export class TheCageIdleNormalPresentation implements FlowStatePresentation {
    private static _tl: gsap.core.Timeline;
    private static _flowStateController: FlowStateController;

    constructor() {

    }

    public static stopCompleteIdlePresentationForAS(): void {
        TheCageIdleNormalPresentation._tl.kill();
        this._flowStateController.finish();
    }

    public start(flowStateController: FlowStateController) {
        TheCageIdleNormalPresentation._flowStateController = flowStateController;
        TheCageIdleNormalPresentation._tl = gsap.timeline();
        TheCage.model.hasWonFsClient = false;
        flowStateController.setSkipCallback(() => this.skip(flowStateController));

    }

    private onComplete(flowStateController: FlowStateController): void {
        const wasBonus: boolean = TheCage.model.gameData?.mode.indexOf("FREESPIN") > -1 && TheCage.model.gameData?.nextMode === TheCageGameMode.NORMAL;
        flowStateController.finish();
    }

    private skip(flowStateController: FlowStateController) {
        TheCageIdleNormalPresentation._tl.kill();
        this.onComplete(flowStateController)
    }
}